import ApplicationController from './application_controller'
import $ from 'jquery'

export default class extends ApplicationController

  # Create accordion
  initialize: ->
    # $(@element).jqxMenu()
    $(@element).menu()
      # focus: (event, ui) -> $(ui.item[0]).children('a').trigger('focus'),
      # select: (event, ui) ->
      #   $(ui.item[0]).children('a').trigger('click') if ui.item[0] isnt ui.item.prevObject[0]
